export const GoBack = (props) => {
  const { size = 18, onClick, verticalAlign = '-3px', marginLeft, marginRight = '8px', top, color = '#726460', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 18 18'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M11.107 10.194l-2.343-.937v-3.34M2.247 4.124v2.25h2.251M2.291 9.75a6.744 6.744 0 10.486-3.376'
        ></path>
      </svg>
    </span>
  );
};
